import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mb-4 text-gray-700" }
const _hoisted_2 = { class: "mb-6" }
const _hoisted_3 = {
  class: "input-form-label",
  for: "coordinator-id"
}
const _hoisted_4 = { value: null }
const _hoisted_5 = ["value"]
const _hoisted_6 = { class: "text-xs text-gray-500 mt-1" }
const _hoisted_7 = { class: "flex gap-3" }

import { ref, watch } from "vue";
import Modal from "@/components/common/Modal.vue";
import Button from "@/components/common/Button.vue";
import { useCoordinatorOptions } from "@/composables/useCoordinatorOptions";
import { t } from "@/i18n";


export default /*#__PURE__*/_defineComponent({
  props: {
  show: { type: Boolean, default: false },
  title: { type: String, default: "" },
  message: { type: String, default: "" },
},
  setup(__props, { emit }: { emit: ({
  hide: [];
  confirm: [coordinatorId?: string];
}), expose: any, slots: any, attrs: any }) {

const props = __props





const coordinatorId = ref<string | null>(null);
const { coordinators, loadCoordinators } = useCoordinatorOptions();

watch(
  () => props.show,
  (visible) => {
    if (visible) {
      coordinatorId.value = null;
      loadCoordinators();
    }
  }
);

const confirm = () => {
  emit("confirm", coordinatorId.value ?? undefined);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Modal, {
    show: __props.show,
    title: __props.title || _unref(t)('deactivate.title'),
    onClose: _cache[2] || (_cache[2] = ($event: any) => (emit('hide')))
  }, {
    default: _withCtx(() => [
      _createElementVNode("p", _hoisted_1, _toDisplayString(__props.message || _unref(t)("deactivate.confirm")), 1),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("label", _hoisted_3, _toDisplayString(_unref(t)("deactivate.coordinator")), 1),
        _withDirectives(_createElementVNode("select", {
          id: "coordinator-id",
          class: "input-form w-full",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((coordinatorId).value = $event))
        }, [
          _createElementVNode("option", _hoisted_4, _toDisplayString(_unref(t)("deactivate.coordinatorNotSet")), 1),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(coordinators), (user) => {
            return (_openBlock(), _createElementBlock("option", {
              key: user.id,
              value: user.id
            }, _toDisplayString(user.fullName || `${user.surname || ""} ${user.name || ""}`.trim()), 9, _hoisted_5))
          }), 128))
        ], 512), [
          [_vModelSelect, coordinatorId.value]
        ]),
        _createElementVNode("p", _hoisted_6, _toDisplayString(_unref(t)("entityScope.coordinatorHint")), 1)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(Button, {
          type: "button",
          variant: "default",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('hide')))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)("common.cancel")), 1)
          ]),
          _: 1
        }),
        _createVNode(Button, {
          type: "button",
          variant: "danger",
          onClick: confirm
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)("deactivate.submit")), 1)
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }, 8, ["show", "title"]))
}
}

})